module.exports = __webpack_public_path__ + "static/references.55aa29db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeContent/img/references.jpg
// module id = 779
// module chunks = 213534597649335